import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
export function Results() {
  const results = [{
    title: 'Rejuvenecimiento Facial Integral',
    description: 'Tratamiento combinado con ácido hialurónico y toxina botulínica.',
    before: 'https://images.unsplash.com/photo-1500522144261-ea64433bbe27?auto=format&fit=crop&q=80&w=600',
    after: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Armonización de Labios',
    description: 'Aumento sutil y perfilado para un resultado natural.',
    before: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=600&grayscale=1',
    after: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=600'
  }];
  return <section id="resultados" className="py-24 md:py-32 bg-surface" data-id="element-214">
      <div className="container mx-auto px-6 md:px-12" data-id="element-215">
        <SectionHeading title="Resultados que hablan por sí solos" subtitle="Casos reales de pacientes que han confiado en nuestro equipo médico para realzar su belleza natural." data-id="element-216" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-16" data-id="element-217">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-218">
              <div className="bg-background rounded-2xl p-6 border border-border shadow-sm" data-id="element-219">
                <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-220">
                  {/* Before */}
                  <div className="relative rounded-xl overflow-hidden aspect-[4/5]" data-id="element-221">
                    <img src={result.before} alt="Antes" className="w-full h-full object-cover filter grayscale opacity-80" data-id="element-222" />
                    <div className="absolute top-4 left-4 bg-black-premium/50 backdrop-blur-md text-white px-3 py-1 rounded-full text-xs tracking-widest uppercase" data-id="element-223">
                      Antes
                    </div>
                  </div>
                  {/* After */}
                  <div className="relative rounded-xl overflow-hidden aspect-[4/5]" data-id="element-224">
                    <img src={result.after} alt="Después" className="w-full h-full object-cover" data-id="element-225" />
                    <div className="absolute top-4 right-4 bg-gold text-gold-foreground px-3 py-1 rounded-full text-xs tracking-widest uppercase shadow-sm" data-id="element-226">
                      Después
                    </div>
                  </div>
                </div>

                <h3 className="font-serif text-2xl text-foreground mb-2 text-center" data-id="element-227">
                  {result.title}
                </h3>
                <p className="text-muted-foreground font-light text-center" data-id="element-228">
                  {result.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-16 text-center" data-id="element-229">
          <p className="text-sm text-muted-foreground italic" data-id="element-230">
            * Los resultados pueden variar según cada paciente. Las imágenes se
            muestran con el consentimiento expreso de los pacientes.
          </p>
        </FadeIn>
      </div>
    </section>;
}